// extracted by mini-css-extract-plugin
export default {"threeDSIframe":"styles__threeDSIframe___ysroi","hidden":"styles__hidden___yQNM0","inheritWidth":"styles__inheritWidth___Q_DYF"};